// extracted by mini-css-extract-plugin
export default {"scanner":"scrollloader_scanner__zieli","load91371":"scrollloader_load91371__n366l"};